"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _formatOwners = require("reference-resolvers/formatters/formatOwners");

var _ReferenceRecord = _interopRequireDefault(require("reference-resolvers/schema/ReferenceRecord"));

var _indexBy = _interopRequireDefault(require("transmute/indexBy"));

var _get = _interopRequireDefault(require("transmute/get"));

var _flattenN = _interopRequireDefault(require("transmute/flattenN"));

var _immutable = require("immutable");

var formatUserId = function formatUserId(user) {
  return String(user.remoteId);
};

var formatUserReference = function formatUserReference(owner, remote) {
  return new _ReferenceRecord.default({
    id: formatUserId(remote),
    label: (0, _formatOwners.formatOwnerLabel)(owner),
    referencedObject: (0, _immutable.fromJS)(remote)
  });
};

var formatUsers = function formatUsers(response) {
  var remotes = (0, _flattenN.default)(1, (0, _immutable.List)(response.map(function (owner) {
    return (0, _immutable.List)(owner.remoteList.map(function (remote) {
      return formatUserReference(owner, remote);
    }));
  })));
  return (0, _indexBy.default)((0, _get.default)('id'), remotes);
};

var _default = formatUsers;
exports.default = _default;
module.exports = exports.default;